import algoliaSearchLib from 'algoliasearch'

const ALGOLIA_ID = 'NG8ACFOLEX';
const ALGOLIA_ADMIN_KEY = '1ee0d79c2c70855ff292d22336887381';
const ALGOLIA_SEARCH_KEY = 'a6d9f1541f42800b02db90d6d2d10ebb';

export const  algoliaSearch = algoliaSearchLib(ALGOLIA_ID, ALGOLIA_ADMIN_KEY);

export const userIndex = algoliaSearch.initIndex('users');
